import React from "react";
import {
  Home,
  Server,
  Briefcase,
  DollarSign,
  CreditCard,
  Info,
  ChevronLeft,
  ChevronRight,
  Phone,
} from "lucide-react";

const links = [
  { label: "Home", href: "/", icon: Home },
  { label: "Hosting", href: "/home#hosting", icon: Server },
  { label: "Portfolio", href: "/portfolio", icon: Briefcase },
  { label: "Pricing", href: "/home#pricing", icon: DollarSign },
  { label: "Pay an Invoice", href: "/invoice-payment", icon: CreditCard },
  { label: "About", href: "/about", icon: Info },
];

export default function WelcomeSidebar({ collapsed, onToggle, onContact }) {
  return (
    <aside
      className={`fixed top-0 left-0 h-full z-40 bg-[#FBFBFB] border-r border-border flex flex-col transition-all duration-300 ${
        collapsed ? "w-16" : "w-60"
      }`}
    >
      {!collapsed && (
        <div className="px-3 py-4 border-b border-border/60">
          <a href="/" className="block w-full">
            <img
              src="https://media.base44.com/images/public/69d14ed5d129627680ef5d0f/8209a6e84_host1help1-logo.svg"
              alt="Host1Help1"
              width="200"
              height="160"
              className="w-full h-auto"
            />
          </a>
        </div>
      )}

      <nav className="flex-1 py-4 px-2 space-y-1 overflow-y-auto">
        {links.map((link) => {
          const Icon = link.icon;
          return (
            <a
              key={link.label}
              href={link.href}
              title={link.label}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-foreground hover:bg-muted transition-colors ${
                collapsed ? "justify-center" : ""
              }`}
            >
              <Icon className="w-5 h-5 text-[#F18D50] shrink-0" />
              {!collapsed && <span>{link.label}</span>}
            </a>
          );
        })}
      </nav>

      <div className="p-2 border-t border-border/60">
        <button
          onClick={onContact}
          title="Contact"
          className={`flex items-center gap-3 w-full px-3 py-2.5 rounded-lg text-sm font-semibold bg-primary text-primary-foreground hover:bg-primary/90 transition-colors ${
            collapsed ? "justify-center" : ""
          }`}
        >
          <Phone className="w-5 h-5 shrink-0" />
          {!collapsed && <span>Contact</span>}
        </button>
      </div>
    </aside>
  );
}